// extracted by mini-css-extract-plugin
module.exports = {"App":"styles_App__1PjfD","AppSidebar":"styles_AppSidebar__3rqJV","AppContent":"styles_AppContent__11JE4","AppWithBanner":"styles_AppWithBanner__2rTP7"};